import { Block, ExpandIconButton, Flex, Typography, theme } from '@aloft/toolkit-sui';
// eslint-disable-next-line aloft/no-sui-chakra
import { chakra } from '@aloft/toolkit-sui/chakra';

import { PropertyPinIcon } from '../../../PropertyPin.tsx';
import {
  RECOMMENDED_COMPS_STATUS_GROUP_LABELS,
  RecommendedCompsStatusGroup,
} from '../../utils/getStatusGroup.ts';
import { getPinColor } from './getPinColor.ts';

export const StatusGroupHeaderRow = ({
  groupId,
  count,
  collapsed,
  colSpan,
  stickyTop,
  onToggle,
}: {
  groupId: RecommendedCompsStatusGroup;
  count: number;
  collapsed: boolean;
  colSpan: number;
  stickyTop: string;
  onToggle: () => void;
}) => {
  const groupLabel = RECOMMENDED_COMPS_STATUS_GROUP_LABELS[groupId];

  return (
    <tr>
      <chakra.td
        colSpan={colSpan}
        style={{
          padding: 0,
          backgroundColor: theme.colors.surface2,
          borderTop: `1px solid ${theme.colors.strokeDefault}`,
          borderBottom: `1px solid ${theme.colors.strokeDefault}`,
          position: 'sticky',
          top: stickyTop,
          zIndex: 2,
        }}
      >
        <Flex
          alignItems="center"
          width="100%"
          cursor="pointer"
          __dangerDoNotUseSx={{
            userSelect: 'none',
            transition: 'background-color 0.15s ease',
            _hover: {
              backgroundColor: theme.colors.hoverTransparentLight,
              '& > *': { backgroundColor: theme.colors.hoverTransparentLight },
            },
          }}
          onClick={onToggle}
        >
          <Flex
            alignItems="center"
            gap="8px"
            padding="12px 16px"
            __dangerDoNotUseSx={{
              position: 'sticky',
              left: 0,
              width: 'max-content',
              backgroundColor: theme.colors.surface2,
            }}
          >
            <ExpandIconButton isCollapsed={collapsed} />
            <PropertyPinIcon color={getPinColor(groupId)} text={groupLabel.charAt(0)} />
            <Typography variant="body1">{groupLabel}</Typography>
            <Typography variant="body2" color="textSecondary">
              ({count})
            </Typography>
          </Flex>
          <Block flex={1} />
        </Flex>
      </chakra.td>
    </tr>
  );
};
